// src/lib/startZiel.ts
// Startseite „/“ (Dominiks Entscheidung 18.10.2026): keine eigene Seite mehr, sondern
// Weiterleitung in den geführten Ablauf. Reine Funktion, getestet.
export type StartZiel =
  | { art: "warten" }
  | { art: "ziel"; pfad: string };

export function startZiel(e: {
  clerkGeladen: boolean;
  eingeloggt: boolean;
  /** location.search inkl. „?“ oder leer */
  search: string;
}): StartZiel {
  const q = new URLSearchParams(e.search);
  // Rückkehr aus dem Stripe-Checkout: CheckoutRefresh (App.tsx) wertet ?checkout=success aus
  // und lädt die Seite neu – bis dahin nicht weiterleiten, sonst ginge das Kauf-Tracking verloren.
  if (q.get("checkout") === "success") return { art: "warten" };
  if (!e.clerkGeladen) return { art: "warten" };
  const rest = q.toString();
  if (!e.eingeloggt) return { art: "ziel", pfad: `/check${rest ? `?${rest}` : ""}` };
  // Dominik 20.10.2026: Eingeloggt immer direkt auf „Meine Objekte“. Vorher wartete „/“ auf
  // die Objektliste (graue Ladeanzeige ohne Seitenleiste, wirkte wie das alte Layout) und
  // schickte Nutzer ohne Objekte nach /check. „Meine Objekte“ hat für 0 Objekte einen
  // eigenen Einstieg „Neues Objekt prüfen“.
  return { art: "ziel", pfad: "/deals" };
}
